import { Canvas, useFrame } from '@react-three/fiber';
import { Stars, Float } from '@react-three/drei';
import { useRef } from 'react';

function TorusKnot() {
  const ref = useRef();
  useFrame(({ clock, mouse }) => {
    ref.current.rotation.x = clock.elapsedTime * 0.07;
    ref.current.rotation.y = clock.elapsedTime * 0.11;
    ref.current.position.x += (mouse.x * 1.8 - ref.current.position.x) * 0.025;
    ref.current.position.y += (mouse.y * 1.0 - ref.current.position.y) * 0.025;
  });
  return (
    <mesh ref={ref} position={[1.8, 0, 0]}>
      <torusKnotGeometry args={[1.2, 0.28, 180, 32]} />
      <meshStandardMaterial color="#6366f1" wireframe transparent opacity={0.35} />
    </mesh>
  );
}

function IcosaFloat({ position, color, rotSpeed }) {
  const ref = useRef();
  useFrame(({ clock }) => {
    ref.current.rotation.x = clock.elapsedTime * rotSpeed;
    ref.current.rotation.y = clock.elapsedTime * rotSpeed * 0.75;
  });
  return (
    <Float speed={1.8} floatIntensity={1.4} rotationIntensity={0.4}>
      <mesh ref={ref} position={position}>
        <icosahedronGeometry args={[0.38]} />
        <meshStandardMaterial color={color} wireframe transparent opacity={0.32} />
      </mesh>
    </Float>
  );
}

function RingOrb({ position }) {
  const ref = useRef();
  useFrame(({ clock }) => {
    ref.current.rotation.x = clock.elapsedTime * 0.3;
    ref.current.rotation.z = clock.elapsedTime * 0.2;
  });
  return (
    <Float speed={1.2} floatIntensity={0.8}>
      <mesh ref={ref} position={position}>
        <torusGeometry args={[0.55, 0.06, 16, 60]} />
        <meshStandardMaterial color="#8b5cf6" wireframe transparent opacity={0.3} />
      </mesh>
    </Float>
  );
}

export default function Scene3D() {
  return (
    <Canvas camera={{ position: [0, 0, 7], fov: 60 }} dpr={[1, 1.5]} gl={{ alpha: true, antialias: true }}>
      <ambientLight intensity={0.15} />
      <pointLight position={[6, 5, 5]} color="#3b82f6" intensity={2.5} />
      <pointLight position={[-5, -3, 3]} color="#8b5cf6" intensity={2} />
      <pointLight position={[0, -5, 2]} color="#22d3ee" intensity={0.8} />
      <Stars radius={90} depth={60} count={2200} factor={2.8} fade speed={0.4} />
      <TorusKnot />
      <IcosaFloat position={[-3.8, 2.2, -1]} color="#8b5cf6" rotSpeed={0.4} />
      <IcosaFloat position={[3.8, -2.2, -1]} color="#3b82f6" rotSpeed={0.6} />
      <IcosaFloat position={[-2.8, -2.5, -2]} color="#22d3ee" rotSpeed={0.28} />
      <IcosaFloat position={[2.8, 2.8, -2]} color="#8b5cf6" rotSpeed={0.5} />
      <RingOrb position={[-4.5, -0.5, -1.5]} />
      <RingOrb position={[4.5, 1.5, -2]} />
    </Canvas>
  );
}
